import {
  ChangeEvent,
  FC,
  useRef,
  useEffect,
  useState,
  useContext,
} from "react";

import { FiSearch } from "react-icons/fi";
import { IoIosClose } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import OrderContext from "../memory/OrderContext";
import { GENERAL } from "../config/Transaction/ProductGeneralConf";

const SearchQuery: FC<{}> = () => {
  const [enteredText, setEnteredText] = useState<string | undefined>(undefined);
  const [forcusSearch, setForcusSearch] = useState(false);
  const ref = useRef<HTMLInputElement>(null);
  const orderContext = useContext(OrderContext);

  const tableStateLoading = useSelector(
    (state: any) => state.rootReducer.table?.isLoading
  );

  const { userToken } = useSelector((state: any) => state.rootReducer.auth);
  const dispatch = useDispatch();

  function handleChange(event: ChangeEvent<HTMLInputElement>): void {
    setEnteredText(event.target.value); 
  }
  function handleClear(event: any): void {
    setEnteredText('');
    if (!tableStateLoading) {
      orderContext?.comeToiniStateSearch();
    }
  }


  useEffect(() => {
    function assertIsNode(e: EventTarget | null): asserts e is Node {
      if (!e || !("nodeType" in e)) {
        throw new Error(`Node expected`);
      }
    }
    const checkIfClickedOutside = ({ target }: MouseEvent) => {
      assertIsNode(target);
      if (!ref.current?.contains(target)) {
        setForcusSearch(false);
      } else {
        setForcusSearch(true);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [forcusSearch]);

  const handleSearch = () => {
    if (enteredText && enteredText.trim() !== "") {
      orderContext?.setPages({
        startPage: GENERAL.startPage,
        orderCode: enteredText,
      });
    }
  };



  return (
    <OrderContext.Consumer>
        {(context) => (
          <div
            ref={ref}
            className={`rounded bg-white flex items-center justify-center  px-6 py-2 mt-0 h-[41px] max-xs:w-full duration-150 ease-in-out max-lg:flex max-lg:justify-between max-lg ${
              forcusSearch ? 'border-semi border border-solid' : ' border-[#c4c4c400] border-2 border-solid'
            } gap-2`}
          >
            <div className="flex float-left mxs:text-xl text-base max-lg:justify-center max-lg:items-center">
              <FiSearch
                className="cursor-pointer"
                onClick={(e: any) => {
                  e.preventDefault();
                  //   setEnteredText(enteredText == '' ? context?.search : enteredText)
                  {
                    enteredText != undefined &&
                      context?.setSearch({
                        value: enteredText
                      });
                  }
                }}
              />
            </div>
            <div className="max-lg:w-[95%] relative flex flex-row items-center">
              <input
                type="text"
                placeholder="Search"
                value={!(enteredText === undefined) ? enteredText : context?.pages.orderCode}
                onChange={handleChange}
                onKeyUp={(e) => {
                  e.key == 'Enter' &&
                    !(enteredText === undefined) &&
                    context?.setSearch({
                      value: enteredText,
                      jwtToken: userToken,
                    });
                }}
                className="focus:outline-none target:outline-nonetext bg-white text-primary3 text-base font-medium max-lg:w-full placeholder:text-semi placeholder:font-medium mxs:placeholder:text-base placeholder:text-sm"
              />
              {(!(enteredText === undefined) ? enteredText :context?.pages.orderCode) && (
                <IoIosClose onClick={handleClear} size={24} className="cursor-pointer top-0 right-0 text-gray-500 hover:text-red-500 focus:outline-none" />
              )}
            </div>
          </div>
        )}
      </OrderContext.Consumer>
  );
};

export default SearchQuery;
